import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import InnerFloatRightStore from '../inner-float-right/store';
import useMount from '@src/utils/hooks/use-mount';
import CommonHeaderStore from '@src/business-components/common-header/store';
import { getOmniData } from '@src/services/omni-api';
import { getParameterByNames } from '@src/utils/device';
import { clearRouteParams } from '@src/utils/build-route-url';
import { DOWNLOAD_QR_POSITION, getDownloadQrIframeUrl } from '@src/utils/qr-track-iframe';
import { createCustomDownloadDataSources, createDownloadDataSources, getDownloadLinks } from '@src/utils/download-data';
import { useEffect } from 'react';

const styles = require('./index.less');

class InnerWrapStore extends BaseStore {
  @observable current = null;
  @observable innerBg = '';
  @observable type = '';
  @observable innerFloatRightStore = new InnerFloatRightStore();
  commonHeaderStore = new CommonHeaderStore({
    changeSwiperCallback: id => {
      this.changeNav(id);
    }
  });
  @observable title = '';
  @observable breadcrumb = [];
  @observable
  titles = {
    攻略资料: require('./images/title-gl.png'),
    江湖快报: require('./images/title-xw.png'),
    视听中心: require('./images/title-st.png')
  };
  @observable
  kvIds = {
    stage: 'ds_cat_8f98015d',
    custom_download: 'ds_cat_64422aa5',
    default_download: 'ds_cat_aa5b92de',
    inner: 'ds_cat_d644834e'
  };

  goto = path => {
    if (path) {
      this.$history.replace(path);
    }
  };

  changeNav = id => {
    if (this.type === 'strategy-list' || this.type === 'news-list') {
      return;
    }
    if (this.type === 'strategy-detail' || this.type === 'news-detail') {
      this.clearDetailRouteParams();
    }
    this.$history.replace(`/?currentPage=${id}`);
  };

  clearDetailRouteParams = () => {
    // 路由参数现在拼在 hash 内部(#/strategy-detail?contentId=xxx), 需一并清理
    clearRouteParams();
  };

  addScrollEvent = () => {
    document.body.addEventListener('scroll', e => {
      // 判断滚动距离大于100
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 100) {
        if (this.commonHeaderStore.isMax) {
          return;
        }
        this.commonHeaderStore.isMax = true;
      } else {
        this.commonHeaderStore.isMax = false;
      }
    });
  };

  getData = async () => {
    // const dataSources = [
    //   {
    //     dataSourceId: 'ds_cat_d644834e' || '',
    //     page: 1,
    //     perPage: 99
    //   }
    // ];
    // const res = await getOmniData('channel_cat_8ae9f08e', dataSources);
    // console.log(res);
  };

  getKvData = async () => {
    try {
      const utmSource = (getParameterByNames('utm_source') || '').trim();
      const dataSources = createDownloadDataSources(this.kvIds);
      const customDataSources = createCustomDownloadDataSources(this.kvIds, utmSource);
      let customDownloadRequest = Promise.resolve({});
      if (customDataSources.length) {
        customDownloadRequest = getOmniData('channel_cat_8ae9f08e', customDataSources).catch(error => {
          console.warn('获取 Omni 渠道下载数据失败，已回退默认官包', error);
          return {};
        });
      }
      const [res, customDownloadRes] = await Promise.all([getOmniData('channel_cat_8ae9f08e', dataSources), customDownloadRequest]);

      // 设置游戏阶段
      const stage = res?.[this.kvIds.stage]?.result?.items?.[0];
      if (stage) {
        this.innerFloatRightStore.type = stage.game_stage_config === 'appointment' ? 1 : 2;
        this.innerFloatRightStore.show = true;
      }

      // 设置内页kv图
      const innerData = res?.[this.kvIds.inner]?.result?.items?.[0];
      if (innerData) {
        this.innerBg = innerData.bg_img?.[0]?.url || '';
      }

      // 处理下载数据
      const download = res?.[this.kvIds.default_download]?.result?.items || [];
      const utmInfo = customDownloadRes?.[this.kvIds.custom_download]?.result?.items || [];
      const downloadUrl = getDownloadLinks(download, utmInfo, utmSource);

      downloadUrl.floatQrcode = getDownloadQrIframeUrl(downloadUrl.qrcode, DOWNLOAD_QR_POSITION.INNER_SIDE);

      // 为浮窗位置赋值
      this.innerFloatRightStore.downloadUrl = downloadUrl;
    } catch (error) {
      console.log(error);
    }
  };

  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }

  use() {
    super.use();

    useMount(() => {
      this.addScrollEvent();
      this.getData();
      this.getKvData();
    });

    useEffect(
      () => {
        this.commonHeaderStore.current = this.current;
      },
      [this.current]
    );
  }
}
export default InnerWrapStore;
